import clsx from "clsx";
import { useInView } from "framer-motion";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useCopyToClipboard } from "react-use";

import { useGetCurrentUrl } from "../../../../hooks/use-get-current-url";
import { IconButton } from "../../icon-button";
import { getFacebookShareLink, getLinkedinShareLink } from "./share-utils";

export const SideCtaInnerShare: FC = () => {
  const [isUrlCopied, setIsUrlCopied] = useState(false);
  const [, copy] = useCopyToClipboard();
  const url = useGetCurrentUrl();
  const handleUrlCopy = useCallback(() => {
    if (url) {
      copy(url);
      setIsUrlCopied(true);
      setTimeout(() => setIsUrlCopied(false), 1000);
    }
  }, [setIsUrlCopied, copy, url]);

  const ref = useRef(null);
  const isInView = useInView(ref);
  useEffect(() => {
    if (!isInView) {
      setIsUrlCopied(false);
    }
  }, [isInView]);

  return !url ? null : (
    <div className="flex flex-col-reverse lg:flex-row gap-3 justify-center w-full">
      <a href={getFacebookShareLink(url)} target="_blank" rel="noreferrer">
        <IconButton
          variant="light-outline"
          icon="facebook"
          className="w-8 h-8 p-[2px] cursor-pointer"
          borderTransparency
        />
      </a>
      <a href={getLinkedinShareLink(url)} target="_blank" rel="noreferrer">
        <IconButton
          variant="light-outline"
          icon="linkedin"
          className="w-8 h-8 p-[5px] cursor-pointer"
          borderTransparency
        />
      </a>
      <div ref={ref}>
        <IconButton
          variant={isUrlCopied ? "primary" : "light-outline"}
          onClick={handleUrlCopy}
          icon={isUrlCopied ? "check" : "link"}
          className={clsx(["w-8 h-8 p-[5px] cursor-pointer transition-all"])}
          borderTransparency={!isUrlCopied}
        />
      </div>
    </div>
  );
};
